import React from 'react';
import { DropdownMenu, SparkIcon, Text } from '@spark';
import { TaskType } from '@/shared/domain/taskTypes';

const ALL_OPTIONS = [
    { value: 'json', label: 'JSON' },
    { value: 'text', label: 'Text' },
    { value: 'custom', label: 'Custom' },
];

/**
 * "Response type" control. Default (flow) variant keeps the corner-arrow row
 * used by Playground Inspect; toolbar variant is the compact Figma Model Setup chrome.
 */
const ResponseTypeSelector = ({ taskType, responseType, onChange, variant = 'flow', showJsonOption = true, disabled = false }) => {
    const visibleOptions = (
        (taskType === TaskType.NER || taskType === TaskType.NER_WITH_RELATIONS)
            ? ALL_OPTIONS.filter((opt) => opt.value !== 'text')
            : ALL_OPTIONS
    ).filter((opt) => showJsonOption || opt.value !== 'json');
    const selected = visibleOptions.find((opt) => opt.value === responseType);
    const displayText = selected ? selected.label : responseType;

    const dropdown = (
        <div className="fs-unmask" style={{ width: 114 }}>
            <DropdownMenu
                showLabel={false}
                text={displayText}
                value={displayText}
                disabled={disabled}
                items={visibleOptions.map((opt) => ({
                    label: opt.label,
                    state: opt.value === responseType ? 'selected' : 'default',
                }))}
                onSelect={(item, index) => {
                    const opt = visibleOptions[index];
                    if (opt) onChange(opt.value);
                }}
            />
        </div>
    );

    if (variant === 'toolbar') {
        return (
            <div className="response-interpreter__response-type response-interpreter__response-type--toolbar">
                <Text className="fs-unmask" variant="base-regular" color="primary">
                    Response type
                </Text>
                {dropdown}
            </div>
        );
    }

    return (
        <div className="response-interpreter__response-type">
            <div className="response-interpreter__response-type-label fs-unmask">
                <span className="response-interpreter__response-type-icon" aria-hidden="true">
                    <SparkIcon slug="arrow-back-up" size="medium" />
                </span>
                <Text variant="base-regular" color="primary">Response type</Text>
            </div>
            {dropdown}
        </div>
    );
};

export default ResponseTypeSelector;
